import { Address } from './address.model';
import { Contact } from './contact.model';
import { Offer } from './offer.model';
import { CurrentPlan } from './current.plan.model';
import { ReplacementOffer } from './replacement.offer.model';
import { CurrentItem } from './current.item.model';

export interface OffersHttpResponse {
  headers: {
    headers: [
      {
        key: 'x-correlation-id';
        value: string;
      }
    ];
  };
  body: {
    offer: Offer;
    current_plan?: CurrentPlan;
    contact_details?: Contact;
    delivery_address?: Address;
    current_item?: CurrentItem;
    replacement_offers?: ReplacementOffer[];
    person_owner_eid?: string;
  };
}
